import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSearch,
  faFilterList,
} from "@fortawesome/pro-regular-svg-icons";
import { Link, useParams } from "react-router-dom";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import InputField from "../../components/InputField";
import ConfirmationModal from "../../components/ConfirmationModal";
import LoadingTablePage from "../LoadingTablePage";
import Breadcrumbs from "../../components/Breadcrumbs";
import { getIndexAdjustmentsByAgreement } from "../../api/BillingGroups";
import TableView from "../../components/TableView";

const IndexAdjustmentsPage = () => {
  /* const { handleExport } = useExporter(); */

  const { agreementPublicId } = useParams();
  const { getAccessToken } = useAuth();
  const [indexAdjustments, setIndexAdjustments] = useState([]);
  const [filteredIndexAdjustments, setFilteredIndexAdjustments] = useState([]);
  const [sortColumn, setSortColumn] = useState("");
  const [selectedIndexAdjustments, setSelectedIndexAdjustments] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [search, setSearch] = useState("");
  const [indexAdjustmentsLoaded, setIndexAdjustmentsLoaded] = useState(false);
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    title: "",
    confirm: () => {},
  });

  useEffect(() => {
    handleGetIndexAdjustmentsByAgreement();
  }, []);

  useEffect(() => {
    const applyFilterAndSort = () => {
      let filtered = indexAdjustments;

      if (search) {
        const searchLower = search.toLowerCase();
        filtered = indexAdjustments.filter(
          (indexAdjustment) =>
            indexAdjustment.indexAdjustmentPublicId
              ?.toLowerCase()
              .includes(searchLower) ||
            indexAdjustment.displayName?.toLowerCase().includes(searchLower) ||
            indexAdjustment.indexAdjustmentPrincipalName
              ?.toLowerCase()
              .includes(searchLower) ||
            indexAdjustment.accountType?.toLowerCase().includes(searchLower) ||
            indexAdjustment.billingGroup?.toLowerCase().includes(searchLower)
        );
      }

      const sorted = [...filtered].sort((a, b) => {
        const aValue = a[sortColumn]?.toString().toLowerCase();
        const bValue = b[sortColumn]?.toString().toLowerCase();
        return sortOrder === "asc"
          ? aValue > bValue
            ? 1
            : -1
          : aValue < bValue
          ? 1
          : -1;
      });

      setFilteredIndexAdjustments(sorted);
    };

    applyFilterAndSort();
  }, [search, indexAdjustments, sortColumn, sortOrder]);

  const handleGetIndexAdjustmentsByAgreement = async () => {
    try {
      const accessToken = await getAccessToken();
      const newIndexAdjustments = await getIndexAdjustmentsByAgreement(
        agreementPublicId,
        accessToken
      );
      setIndexAdjustments(newIndexAdjustments);
      setFilteredIndexAdjustments(newIndexAdjustments);
      setIndexAdjustmentsLoaded(true);
    } catch (error) {
      console.error(error);
      setIndexAdjustmentsLoaded(true);
    }
  };

  return (
    <>
      <HeaderBar />
      <div className="flex flex-col">
        <div className="flex flex-row">
          <Sidebar />
          <main className="page">
            <div className="absolute w-full pointer-events-none">
              <LoadingTablePage
                title={"Index adjustments"}
                loading={!indexAdjustmentsLoaded}
              />
            </div>

            <div
              className={`${
                !indexAdjustmentsLoaded ? "loading" : ""
              } page-content`}
            >
              <Breadcrumbs /> {/* Add Breadcrumbs component */}
              <div className="flex justify-between items-center">
                <h2 className="text-2xl text-black font-bold pb-2">
                  Index adjustments
                </h2>
                <Link
                  to="/indexAdjustment/createindexAdjustment"
                  className="btn-primary hidden"
                >
                  {" "}
                  {/* DOLD */}
                  <FontAwesomeIcon
                    icon={faPlus}
                    className="mr-2 text-lg"
                  />{" "}
                  Create index adjustment
                </Link>
              </div>
              <div className="rounded-md shadow-md border w-full p-4">
                <div className="flex mb-2 gap-4 justify-between">
                  <div className="flex">
                    <button className="btn-outline-primary icon hidden">
                      {" "}
                      {/* DOLD */}
                      <FontAwesomeIcon
                        icon={faFilterList}
                        className="mr-2 text-lg"
                      />
                      Filter
                    </button>
                  </div>
                  <div className="flex items-center">
                    <InputField
                      iconLeft={false}
                      icon={faSearch}
                      placeholder={"name, account type"}
                      value={search}
                      onChange={(v) => {
                        setSearch(v.target.value);
                      }}
                    />
                    <button className="btn-outline-primary ml-4 hidden">
                      {" "}
                      {/* DOLD */}
                      Export to excel
                    </button>
                  </div>
                </div>

                <div className="overflow-x-auto pb-[250px] mb-[-250px]">
                  <TableView
                    data={filteredIndexAdjustments}
                    selectedRows={selectedIndexAdjustments}
                    setSelectedRows={setSelectedIndexAdjustments}
                    noDelete={false}
                    noCheckbox={true}
                    showActions={false}
                    disableLink={true}
                    columns={[
                      { key: "name", label: "Name" },
                      //index?
                      //UpdatedBy
                      //updatedDate
                      { key: "indexFactor", label: "Index factor" },
                    ]}
                    primaryKey="indexAdjustmentPublicId"
                    basePath={`/${agreementPublicId}/indexadjustment`}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      <ConfirmationModal
        isOpen={confirmState.isOpen}
        title={confirmState.title}
        onClose={() => setConfirmState((s) => ({ ...s, isOpen: false }))}
        onConfirm={() => {
          setConfirmState((s) => ({ ...s, isOpen: false }));
          confirmState.confirm();
        }}
      />
    </>
  );
};

export default IndexAdjustmentsPage;
